import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  getFilterCount,
  getFilterTitleWithCount,
} from 'src/utils/marketplace/filter';

import { ResetButton } from '../ResetButton';
import s from './MobileHead.module.scss';

type Props = {
  filterKey: string;
  titleKey: string;
};

export function MobileHead({ filterKey, titleKey }: Props) {
  const { watch } = useFormContext();

  const selectedFilters = watch(filterKey);

  const count = getFilterCount(selectedFilters);

  return (
    <div className={s.filterTitle}>
      <h4>{getFilterTitleWithCount(titleKey, count)}</h4>

      {count ? (
        <ResetButton titleKey={`${titleKey}-mobile`} filterKey={filterKey} />
      ) : null}
    </div>
  );
}
